Namespace 'Settings.Views.AccountSettings.SocialAccounts'

class Settings.Views.AccountSettings.SocialAccounts.GoogleMyBusinessAccountsView extends Backbone.View
  className: 'modal hide fade in'
  template: JST['backbone/templates/account_settings/social_accounts/google_my_business_accounts']

  events:
    'click .gmb-account-choose': 'submit'
    'click #close': 'redirectToSocialAccounts'

  initialize: (accounts) ->
    @accounts = accounts
    @modal = buttons: [], title: I18n.t('social_accounts.google_my_business.accounts.title')

  render: ->
    if @accounts.length == 0
      @notifyNoAccountsAvailable()
    else
      @$el.html(@template({accounts: @accounts}))
      @$el.modal({backdrop: 'static', keyboard: false})
      @$el.modal()
    @

  notifyNoAccountsAvailable: ->
    swal({
      title: I18n.t('social_accounts.google_my_business.accounts.no_account_notification.title'),
      text: I18n.t('social_accounts.google_my_business.accounts.no_account_notification.text'),
      type: 'info',
      showCancelButton: false,
      confirmButtonClass: 'close',
      cancelButtonClass: 'close',
      confirmButtonText: I18n.t(
        'social_accounts.google_my_business.accounts.no_account_notification.button_text'
      ),
      closeOnConfirm: true
    })
    swal.close = => @redirectToSocialAccounts()

  submit: (event) ->
    @$el.children('.tab-content').empty().addClass('processing')
    $clickedButton = $(event.currentTarget)
    chosenAccountUid = $clickedButton.data('value')
    account = @accounts.findWhere(uid: chosenAccountUid)
    account.save(null, {
    success: =>
      @redirectToSocialAccounts()
    error: =>
      swal({
        title: I18n.t('social_accounts.google_my_business.accounts.error_notification.title'),
        text: I18n.t('social_accounts.google_my_business.accounts.error_notification.text'),
        type: 'info',
        showCancelButton: false,
        confirmButtonClass: 'close',
        cancelButtonClass: 'close',
        confirmButtonText: I18n.t('social_accounts.google_my_business.accounts.error_notification.button_text'),
        closeOnConfirm: true
      })
      swal.close = => @redirectToSocialAccounts()
    })

  redirectToSocialAccounts: ->
    window.location = '/keepcon/social_accounts'

  close: ->
    @modalTab.destroy()
